import { List, useTable } from "@refinedev/antd";
import { Button, Space, Table, Tag, Typography } from "antd";
import dayjs from "dayjs";
import { Link, useNavigate } from "react-router";

import { DATE_TIME_FORMAT, STAFF_STATUS } from "../labels";
import type { StaffMember } from "../types";

/** /team: the team; each member opens on their own page (permission `staff.manage`). */
export function TeamPage() {
  const navigate = useNavigate();
  const { tableProps } = useTable<StaffMember>({
    resource: "staff",
    pagination: { mode: "off" },
    syncWithLocation: false,
  });

  return (
    <List
      title="Ekip"
      headerButtons={
        <Button type="primary" onClick={() => navigate("/team/new")}>
          Ekip üyesi ekle
        </Button>
      }
    >
      <Table {...tableProps} rowKey="id" scroll={{ x: "max-content" }}>
        <Table.Column<StaffMember>
          title="Ad Soyad"
          dataIndex="name"
          render={(name: string, member) => (
            <Space direction="vertical" size={0}>
              <Link to={`/team/${member.id}`}>
                <Typography.Text strong>{name}</Typography.Text>
              </Link>
              <Typography.Text type="secondary">{member.email}</Typography.Text>
            </Space>
          )}
        />
        <Table.Column<StaffMember>
          title="Roller"
          dataIndex="roles"
          render={(memberRoles: StaffMember["roles"]) =>
            memberRoles.map((role) => (
              <Tag key={role.id} color={role.isOwner ? "purple" : "blue"}>
                {role.name}
              </Tag>
            ))
          }
        />
        <Table.Column<StaffMember>
          title="Durum"
          dataIndex="status"
          render={(status: StaffMember["status"], member) => (
            <Space direction="vertical" size={0}>
              <Tag color={STAFF_STATUS[status]?.color}>{STAFF_STATUS[status]?.label}</Tag>
              {status === "invited" && member.invitationExpiresAt ? (
                <Typography.Text type="secondary">
                  Son geçerlilik: {dayjs(member.invitationExpiresAt).format(DATE_TIME_FORMAT)}
                </Typography.Text>
              ) : null}
              {status === "active" && !member.twoFactorEnabled ? (
                <Typography.Text type="warning">Doğrulama kurulmadı</Typography.Text>
              ) : null}
            </Space>
          )}
        />
      </Table>
    </List>
  );
}
